module.exports = __webpack_public_path__ + "media/images/icons/comments_fill-0ca9397297f1cf43c2b2ef7c798d76bd.svg";